<!--
 * @Description:
 * @Author: mdb
 * @Date: 2023-04-13 13:53:26
 * @LastEditTime: 2023-04-18 10:16:24
 * @LastEditors: mdb
-->
<template>
  <Home />
</template>

<script setup lang="ts">
import { provide } from 'vue'
import Home from '@/views/marketing/index/index.vue'

enum Subdomain {
  Fbu = 'fbu',
  Lbu = 'lbu'
}
provide('subdomain', Subdomain.Lbu)
</script>
<script lang="ts">
export default { name: 'DcCosLbuDataReport' }
</script>

<style scoped></style>
